import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoutes: string[]; // allowed paths for user role
}

const ProtectedRoute = ({ children, allowedRoutes }: ProtectedRouteProps): JSX.Element => {
  const { token } = useSelector((state: { user: { role: string; token: string | null } }) => state.user);
  const isLoggedIn = !!token;
  const location = useLocation();

  if (!isLoggedIn) {
    // Redirect to login if not logged in
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If logged in but URL not allowed for role, redirect to first permitted route
  const isAllowed = allowedRoutes.some((allowedPath) => location.pathname.startsWith(allowedPath));

  if (!isAllowed) {
    return <Navigate to={allowedRoutes[0] || '/login'} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
